import React from 'react'

import { Box } from '@gousto-internal/citrus-react'

export const RecipeFeedback = () => {
  return <Box>RecipeFeedback</Box>
}
